import React from 'react';

export const iconArray = [
  'bff-approve',
  'bff-arrow-down-up',
  'bff-attention',
  'bff-bar-graph',
  'bff-boards',
  'bff-brand-collective',
  'bff-brand-guide',
  'bff-build',
  'bff-calendar',
  'bff-chat',
  'bff-check-in',
  'bff-check-out',
  'bff-check-mark',
  'bff-clock',
  'bff-close',
  'bff-cloud-download',
  'bff-color-hexa',
  'bff-comment',
  'bff-confirmation',
  'bff-copy',
  'bff-credit-card',
  'bff-crop',
  'bff-cursor',
  'bff-custom-fields',
  'bff-arrow-up',
  'bff-arrow-down',
  'bff-arrow-left',
  'bff-arrow-right',
  'bff-caret-up',
  'bff-caret-down',
  'bff-caret-left',
  'bff-caret-right',
  'bff-dollar-sign',
  'bff-download',
  'bff-draft',
  'bff-edit',
  'bff-ellipsis',
  'bff-email',
  'bff-embed',
  'bff-enter',
  'bff-facebook-icon',
  'bff-facebook-icon-square',
  'bff-filters',
  'bff-face-happy',
  'bff-face-sad',
  'bff-font-type',
  'bff-form',
  'bff-full-screen',
  'bff-ingest',
  'bff-general-settings',
  'bff-grid-view',
  'bff-horizontal-orientation',
  'bff-insights',
  'bff-integrations',
  'bff-knowledge-base',
  'bff-label',
  'bff-language',
  'bff-link',
  'bff-linked-in',
  'bff-linkedin-icon-square',
  'bff-list-view',
  'bff-location-marker',
  'bff-logo',
  'bff-manage-subscription',
  'bff-manage-versions',
  'bff-menu',
  'bff-merge',
  'bff-metadata',
  'bff-move',
  'bff-new-tab',
  'bff-notification-settings',
  'bff-notifications',
  'bff-panoramic-orientation',
  'bff-paperclip',
  'bff-payment',
  'bff-people',
  'bff-person',
  'bff-phone',
  'bff-pin',
  'bff-plus',
  'bff-portal',
  'bff-press-release',
  'bff-print',
  'bff-private',
  'bff-public',
  'bff-quote-end',
  'bff-quote-start',
  'bff-ratio-lock',
  'bff-refresh',
  'bff-remove',
  'bff-reorder',
  'bff-request-download',
  'bff-rules-engine',
  'bff-save',
  'bff-score-meter',
  'bff-search',
  'bff-sent',
  'bff-settings',
  'bff-share',
  'bff-show',
  'bff-hide',
  'bff-square-orientation',
  'bff-star-hollow',
  'bff-star',
  'bff-stealth',
  'bff-tag',
  'bff-template-editor',
  'bff-tip',
  'bff-tool-tip',
  'bff-trash',
  'bff-twitter-icon',
  'bff-unapprove',
  'bff-unlink',
  'bff-upload',
  'bff-user-admin',
  'bff-user-collaborator',
  'bff-user-guest',
  'bff-user-accepted',
  'bff-user-invited',
  'bff-user-settings',
  'bff-vertical-orientation',
  'bff-visit-media',
  'bff-warning',
  'bff-you-tube-icon',
  'bff-zip-file',
  'bff-zoom-in',
  'bff-zoom-out',
];

export const Icons = () => {
  const buildIcons = () => (
    iconArray.map((el, i) => (
      <div className="icon-container" key={i}>
        <span className={`${el}`} />
        <h4 className="mls">{el}</h4>
      </div>
    ))
  );

  return (
    <div className="example-container icon-wrapper">
      {buildIcons()}
    </div>
  );
};

export default Icons;
